<header>
    <nav class="navbar navbar-expand-lg justify-content-between navbar-light ">
        <!-- <button class="navbar-toggler bg-transparent border-0  d-block" type="button" data-toggle="collapse" data-target="#navbarSupportedsidebar"
            aria-controls="navbarSupportedsidebar" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fa-solid fa-angles-left"></i>
        </button> -->
        <a class="navbar-brand mr-0 pl-4" [routerLink]="['/']"><img loading="lazy" src="../../../../assets/images/new/myvip_logo.png" height="60" alt=""></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
            <ul class="navbar-nav text-white">
                <li class="nav-item px-2 ">
                    <a class="nav-link text-white" [routerLink]="['/admin/our-features']" routerLinkActive="active">Our features</a>
                </li>
                <li class="nav-item px-2">
                    <a class="nav-link text-white" [routerLink]="['/admin/prices-and-packages']" routerLinkActive="active">FAQs</a>
                </li>
                <li class="nav-item px-2">
                    <a class="nav-link text-white" href="https://wa.link/smd9ga" target="_blank" routerLinkActive="active">Help Center</a>
                </li>
                <!-- <li class="nav-item px-2">
                    <a class="nav-link text-white">Inquiry</a>
                </li> -->
            </ul>


        </div>

        <div class="profile_div d-flex text-white-50 align-items-center"
            id="">
            <div class="welcome_dorp text-right pr-3">
                <div class="dropdown">
                    <button class=" dropbtn" type="button" data-toggle="dropdown"
                        aria-expanded="false">
                        <i class="fa-solid fa-message"></i>
                    </button>
                    <div class="dropdown-menu shadow notification_icon">
                        <p class="noti_sub_head">ANNOUNCEMENTS</p>
                        <div class="noti_div" *ngFor="let announcement of announcements" (click)="openAnnModal(announcement.id)">
                            <div class="noti_content">
                                <div class="noti_p">
                                    <img loading="lazy" src="{{imgUrl}}{{announcement.image}}" class="rounded" *ngIf="announcement.image != ''">
                                    <img loading="lazy" src="../../../assets/images/new/megaphone.png" class="rounded" *ngIf="announcement.image == ''">
                                </div>
                                <p style="width: 100%;">{{ announcement.title.substr(0,70) }}<i *ngIf="announcement.titleLength > 70">...</i></p>
                                <span>{{ announcement.created * 1000 | date: 'medium' }}</span>
                            </div>
                            <hr style="margin: 0 0 8px 0;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="welcome_dorp text-right pr-3">
                <div class="dropdown">
                    <button class=" dropbtn" type="button" data-toggle="dropdown"
                        aria-expanded="false">
                        <i class="fa-solid fa-bell  pr-3"></i>
                    </button>
                    <div class="dropdown-menu shadow notification_icon">
                        <p class="noti_sub_head">NOTIFICATIONS</p>
                        <div class="noti_div" *ngFor="let notification of notifications">
                            <div class="noti_content">
                                <div class="noti_p">
                                    <img loading="lazy" src="../../../assets/images/new/coin$s.svg" class="rounded" *ngIf="notification.viptoken_deduct_id == 0">
                                    <img loading="lazy" src="../../../assets/images/new/google_iocn.png" class="rounded" *ngIf="notification.viptoken_txn_id == 0 && notification.viptoken_deduct.type == 1">
                                    <img loading="lazy" src="../../../assets/images/gbb.png" class="rounded" *ngIf="notification.viptoken_txn_id == 0 && notification.viptoken_deduct.type == 6">
                                    <img loading="lazy" src="../../../assets/images/gg.png" class="rounded" *ngIf="notification.viptoken_txn_id == 0 && notification.viptoken_deduct.type == 4">
                                    <img loading="lazy" src="../../../assets/images/st.png" class="rounded" *ngIf="notification.viptoken_txn_id == 0 && notification.viptoken_deduct.type == 5">
                                    <img loading="lazy" src="../../../assets/images/tp_stand.jpg" class="rounded" *ngIf="notification.viptoken_txn_id == 0 && notification.viptoken_deduct.type == 7">
                                </div>
                                <p>{{ notification.text }}</p>
                                <span>{{ notification.created * 1000 | date: 'medium' }}</span>
                                <i class="fas fa-download" *ngIf="notification.viptoken_deduct_id == 0" title="Download receipt" (click)="downloadReceipt(notification.viptoken_txn.stripe_invoice_id)"></i>
                            </div>
                            <hr style="margin: 0 0 8px 0;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="welcome_dorp text-right pr-3">
                <div class="dropdown">
                    <button class=" dropbtn   dropdown-toggle" type="button" data-toggle="dropdown"
                        aria-expanded="false">
                        Welcome {{ adminName }}
                    </button>
                    <div class="dropdown-menu shadow">
                        <button class="dropdown-item" type="button" [routerLink]="['/edit-profile']">Edit profile</button>
                        <button class="dropdown-item" type="button" (click)="logout()">Log out</button>
                    </div>
                </div>
                <p>{{ adminEmail }}</p>
            </div>
            <i class="fa-solid fa-user pr-3"></i>
        </div>

    </nav>
</header>